export function PageHeader({ title, subtitle, actions, children }) {
  return (
    <div className="sticky top-0 z-10 border-b border-slate-200 bg-white px-4 py-4 md:px-7">
      <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
        <div className="min-w-0">
          <h1 className="font-display text-xl font-bold text-slate-900 tracking-tight">{title}</h1>
          {subtitle && <div className="mt-0.5 text-sm text-slate-500">{subtitle}</div>}
        </div>
        {actions && <div className="flex max-w-full items-center gap-2 overflow-x-auto pb-0.5 sm:shrink-0">{actions}</div>}
      </div>
      {children}
    </div>
  );
}
